import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M23.2434 19.2383H20.9433V0.75662C20.9433 0.343001 20.6003 0 20.1866 0H3.81337C3.38966 0 3.05675 0.343001 3.05675 0.75662V19.2383H0.75662C0.343001 19.2383 0 19.5712 0 19.995C0 20.4187 0.343001 20.7516 0.75662 20.7516H3.81337H20.1866H23.2434C23.657 20.7516 24 20.4086 24 19.995C24 19.5813 23.657 19.2383 23.2434 19.2383ZM4.56999 19.2383V1.51324H19.43V19.2383H4.56999Z"
}), React.createElement("path", {
  d: "M10.6642 11.0063L8.30351 6.84991H6.68939V13.5384H8.30351V9.37198L10.6743 13.5384H12.2783V6.84991H10.6642V11.0063Z"
}), React.createElement("path", {
  d: "M13.296 13.5384H14.9102V10.8751H17.5028V9.63428H14.9102V8.09077H17.7651V6.84991H13.296V13.5384Z"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: "23.79",
  height: "20.57",
  fill: "white",
  transform: "scale(1.00883)"
})))), "IconInvoice");